import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Form, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

const EncabezadoComponent = (props) => {
  const [formObject, actualizarObject] = useState({
    servicio: "",
  });

  const actualizarState = (e) => {
    props.evento(e.target.value);
    actualizarObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };

  const { servicio } = formObject;
  return (
    <Fragment>
      <Form>
        <Form.Row className="row-select">
          <Form.Group
            id="encabezado-label"
            as={Col}
            controlId="formGridCity"
            align="right"
          >
            <Form.Label>{props.componente}</Form.Label>
          </Form.Group>
          {props.select ? (
            <Form.Group as={Col} controlId="select" align="left">
              <Form.Control
                as="select"
                name="servicio"
                onChange={actualizarState}
                value={servicio}
              >
                {props.selectArray !== undefined && props.selectArray ? (
                  props.selectArray.map((index, i) => {
                    return (
                      <Fragment key={i}>
                        <option value={props.selectArray[i].nombre}>
                          {props.selectArray[i].nombre}
                        </option>
                      </Fragment>
                    );
                  })
                ) : (
                  <Fragment></Fragment>
                )}
              </Form.Control>
            </Form.Group>
          ) : (
            <Fragment></Fragment>
          )}
        </Form.Row>
      </Form>
    </Fragment>
  );
};

EncabezadoComponent.propTypes = {
  select: PropTypes.bool,
  componente: PropTypes.string,
  selectArray: PropTypes.array,
  evento: PropTypes.func,
};

export default EncabezadoComponent;
